import React, { useEffect, useState } from 'react';
import GridCellWrapper from '../../../../components/grid-cell-wrapper/GridCellWrapper';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import { StateModel } from '../../../../redux/store';
import { addDecimalNumbers } from '../../../../utils/mathUtils';
import { AuftragPositionModel } from '../../../../models/AuftragPositionModel';

interface AuftragoverviewProps {
  currentAuftragspositionen: AuftragPositionModel[];
}

const Auftragoverview = (props: AuftragoverviewProps) => {
  const [verpackungen, setVerpackungen] = useState({});
  const [lademittel, setLademittel] = useState({});
  const [bruttogewicht, setBruttogewicht] = useState(0.0);
  const [lademeter, setLademeter] = useState(0.0);
  const [volumen, setVolumen] = useState(0.0);
  const [stellplaetze, setStellplaetze] = useState(0);

  useEffect(() => {
    updateLocalState();
  }, [props.currentAuftragspositionen]);

  const updateLocalState = () => {
    let tmpVerpackung = {};
    let tmpLademittel = {};
    let bruttogewicht = 0.0;
    let lademeter = 0.0;
    let volumen = 0.0;
    let anzahlStellplaetze = 0.0;

    props.currentAuftragspositionen?.forEach(pos => {
      if (pos.verpackung && pos.verpackungAnzahl)
        tmpVerpackung = addVerpackungseinheit(
          tmpVerpackung,
          pos.verpackung.value,
          pos.verpackungAnzahl
        );
      if (pos.bruttoGewicht)
        bruttogewicht = addDecimalNumbers([bruttogewicht, pos.bruttoGewicht]);

      if (pos.volumenCBM)
        volumen = +addDecimalNumbers([volumen, pos.volumenCBM]).toFixed(3);

      if (pos.anzahlStellplaetze) {
        anzahlStellplaetze = addDecimalNumbers([
          anzahlStellplaetze,
          pos.anzahlStellplaetze,
        ]);
      }
      if (pos.lademeter)
        lademeter = addDecimalNumbers([lademeter, pos.lademeter]);

      if (pos.lademittel && pos.lademittelAnzahl)
        tmpLademittel = addVerpackungseinheit(
          tmpLademittel,
          pos.lademittel.value,
          pos.lademittelAnzahl
        );
    });
    setVerpackungen(tmpVerpackung);
    setLademittel(tmpLademittel);
    setBruttogewicht(bruttogewicht);
    setLademeter(lademeter);
    setVolumen(volumen);
    setStellplaetze(anzahlStellplaetze);
  };

  const addVerpackungseinheit = (
    tmpVerpackungseinheit: any,
    verpackungseinheitName: string,
    verpackungseinheitAnzahl: number
  ) => {
    if (!isNaN(verpackungseinheitAnzahl)) {
      if (tmpVerpackungseinheit.hasOwnProperty(verpackungseinheitName)) {
        let anzahlVerpackungseinheit = parseInt(
          tmpVerpackungseinheit[verpackungseinheitName]
        );
        anzahlVerpackungseinheit += Number(verpackungseinheitAnzahl);
        tmpVerpackungseinheit[verpackungseinheitName] =
          anzahlVerpackungseinheit;
      } else {
        tmpVerpackungseinheit[verpackungseinheitName] =
          verpackungseinheitAnzahl;
      }
    }
    return tmpVerpackungseinheit;
  };

  return (
    <GridCellWrapper classes='overview' label='Übersicht'>
      <div>
        {Object.entries(verpackungen).map(([key, value]) => (
          <span key={key}>
            {value} {key}
          </span>
        ))}
        {Object.entries(lademittel).map(([key, value]) => (
          <span key={key}>
            {value} {key}
          </span>
        ))}
        <NumberFormat
          value={bruttogewicht}
          displayType={'text'}
          thousandSeparator={'.'}
          decimalSeparator={','}
          suffix={' kg'}
        />
        <NumberFormat
          value={volumen}
          displayType={'text'}
          thousandSeparator={'.'}
          decimalSeparator={','}
          suffix={' cbm'}
        />
        <NumberFormat
          value={stellplaetze}
          displayType={'text'}
          thousandSeparator={'.'}
          decimalSeparator={','}
          suffix={' STP'}
        />
        <NumberFormat
          value={lademeter}
          displayType={'text'}
          thousandSeparator={'.'}
          decimalSeparator={','}
          suffix={' LDM'}
        />
      </div>
    </GridCellWrapper>
  );
};

const mapStateToProps = (state: StateModel) => ({
  resetToggle: state.Auftragserfassung.resetToggle,
  currentAuftragspositionen: state.Auftragserfassung.currentAuftragpos,
});

export default connect(mapStateToProps, {})(Auftragoverview);
